// src/components/Layout.jsx
export default function Layout({ children }) {
    return (
      <div
        className="min-h-screen w-screen bg-cover bg-center text-white overflow-hidden z-0"
        style={{ backgroundImage: 'url(/images/Pixelbg3.png)' }}
      >
        {children}
      </div>
    );
  }
